
import { defineComponent } from 'vue'

import { store } from '@/store'
import AppSetting from '@/components/settings/AppSetting.vue'
import InputSelect from '@/components/inputs/InputSelect.vue'
import InputSelectHorizontal from '@/components/inputs/InputSelectHorizontal.vue'

export default defineComponent({
  name: 'UserSettings',
  components: { AppSetting, InputSelect, InputSelectHorizontal },
  setup() {
    
    const user = store.user.get(state => state.user)
    const settings = user.value ? user.value.settings : null

    async function save() {
      settings && await store.user.updateSettings(settings)
    }

    return { user, settings, save }
  }
})
